import { render, staticRenderFns } from "./ShortableReview.vue?vue&type=template&id=5814bb49"
import script from "./ShortableReview.vue?vue&type=script&lang=js"
export * from "./ShortableReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports